import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { accommodations } from "@/mocks/accommodations";
import Navbar from "@/pages/home/components/Navbar";
import DetailHero from "./components/DetailHero";
import DetailInfo from "./components/DetailInfo";
import DetailBookingCard from "./components/DetailBookingCard";
import DetailReviews from "./components/DetailReviews";
import RelatedAccommodations from "./components/RelatedAccommodations";

export default function DetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const accommodation = accommodations.find((a) => a.id === Number(id));

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [id]);

  if (!accommodation) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-stone-50">
        <div className="w-16 h-16 flex items-center justify-center mb-4">
          <i className="ri-home-2-line text-5xl text-stone-300"></i>
        </div>
        <p className="text-stone-400 text-lg mb-4">숙소를 찾을 수 없어요.</p>
        <button
          onClick={() => navigate("/")}
          className="bg-amber-500 text-white px-6 py-2.5 rounded-full font-semibold cursor-pointer hover:bg-amber-600 transition-colors whitespace-nowrap"
        >
          홈으로 돌아가기
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />

      {/* Back breadcrumb */}
      <div className="pt-20 pb-0 px-4 md:px-6 max-w-6xl mx-auto">
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-sm text-stone-500 hover:text-amber-600 transition-colors cursor-pointer mt-4 mb-0"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-left-line text-sm"></i>
          </div>
          숙소 목록으로 돌아가기
        </button>
      </div>

      {/* Hero images */}
      <div className="max-w-6xl mx-auto px-4 md:px-6 mt-4">
        <DetailHero accommodation={accommodation} />
      </div>

      {/* Main content + booking card */}
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-8">
        <div className="flex flex-col lg:flex-row gap-10">
          {/* Left: info */}
          <div className="flex-1 min-w-0">
            <DetailInfo accommodation={accommodation} />
            <DetailReviews
              accommodationId={accommodation.id}
              accommodationName={accommodation.name}
              rating={accommodation.rating}
              reviewCount={accommodation.reviewCount}
            />
            <RelatedAccommodations currentId={accommodation.id} area={accommodation.area} />
          </div>

          {/* Right: booking card */}
          <DetailBookingCard
            accommodationId={accommodation.id}
            price={accommodation.price}
            rating={accommodation.rating}
            reviewCount={accommodation.reviewCount}
            airbnbUrl={accommodation.airbnbUrl}
            hostName={accommodation.hostName}
          />
        </div>
      </div>

      {/* Footer minimal */}
      <footer className="bg-stone-100 mt-12 py-8 px-6 text-center">
        <p className="text-stone-500 text-sm">
          © 2025 후쿠오카 한울 · 한국인 호스트가 운영하는 후쿠오카 숙소 컬렉션
        </p>
        <p className="text-stone-400 text-xs mt-1">
          모든 예약은 에어비앤비 공식 플랫폼을 통해 이루어집니다
        </p>
      </footer>
    </div>
  );
}
